import { render, staticRenderFns } from "./pay_link_debit.vue?vue&type=template&id=50f644aa"
import script from "./pay_link_debit.vue?vue&type=script&lang=js"
export * from "./pay_link_debit.vue?vue&type=script&lang=js"
import style0 from "./pay_link_debit.vue?vue&type=style&index=0&id=50f644aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports